/**
 * Public OPDS Catalogs
 * Source: https://wiki.mobileread.com/wiki/OPDS#Online_OPDS_Catalogs
 */

export interface PublicOPDSCatalog {
  id: string;
  name: string;
  url: string;
  description: string;
  language: string;
  active: boolean;
}

export const PUBLIC_OPDS_CATALOGS: PublicOPDSCatalog[] = [
  {
    id: 'feedbooks',
    name: 'Feedbooks',
    url: 'https://www.feedbooks.com/catalog.atom',
    description: 'Digital book distribution platform with public domain and original works',
    language: 'en',
    active: true,
  },
  {
    id: 'internet-archive',
    name: 'Internet Archive',
    url: 'https://bookserver.archive.org/catalog/',
    description: 'Digital library of free books and media',
    language: 'en',
    active: true,
  },
  {
    id: 'standard-ebooks',
    name: 'Standard Ebooks',
    url: 'https://standardebooks.org/opds/all',
    description: 'High quality, carefully formatted editions of public domain books',
    language: 'en',
    active: true,
  },
  {
    id: 'project-gutenberg',
    name: 'Project Gutenberg',
    url: 'https://m.gutenberg.org/ebooks.opds/',
    description: 'Over 70,000 free eBooks in the public domain',
    language: 'en',
    active: true,
  },
  {
    id: 'manybooks',
    name: 'ManyBooks',
    url: 'https://manybooks.net/opds/index.php',
    description: 'Free eBooks for your Kindle, iPad, Nook, Android and more',
    language: 'en',
    active: true,
  },
  {
    id: 'smashwords',
    name: 'Smashwords',
    url: 'https://www.smashwords.com/lexcycle/stanza',
    description: 'Independent author publishing platform',
    language: 'en',
    active: true,
  },
  {
    id: 'baen-ebooks',
    name: 'Baen eBooks',
    url: 'http://www.baenebooks.com/stanza.aspx',
    description: 'Science fiction and fantasy publisher',
    language: 'en',
    active: true,
  },
  {
    id: 'gallica',
    name: 'Gallica (BnF)',
    url: 'https://gallica.bnf.fr/opds',
    description: 'Digital library of the Bibliothèque nationale de France',
    language: 'fr',
    active: true,
  },
  {
    id: 'flibusta',
    name: 'Flibusta',
    url: 'http://flibusta.is/opds',
    description: 'Russian language eBook library',
    language: 'ru',
    active: true,
  },
  {
    id: 'litres',
    name: 'LitRes',
    url: 'https://www.litres.ru/pages/catalit_epub/',
    description: 'Russian eBook store',
    language: 'ru',
    active: true,
  },
  {
    id: 'chitanka',
    name: 'Chitanka',
    url: 'https://chitanka.info/opds',
    description: 'Bulgarian digital library',
    language: 'bg',
    active: true,
  },
  {
    id: 'publius',
    name: 'Publius Books',
    url: 'https://www.publiusbooks.com/opds/',
    description: 'Independent publisher OPDS catalog',
    language: 'en',
    active: true,
  },
  {
    id: 'arxiv',
    name: 'arXiv',
    url: 'http://arxiv.maplepop.com/catalog/',
    description: 'Scientific research papers repository',
    language: 'en',
    active: true,
  },
];
